<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <DrawerToolbar title="Add Component" :admin="true" @close="close" />

      <div class="pa-4">
        <div class="section-title mb-6">Select a Component Type</div>

        <div
          v-for="option in componentOptions"
          :key="option.type"
          class="option-card d-flex align-center pa-4 mb-6"
          role="button"
          tabindex="0"
          @click="handleSelect(option)"
          @keydown.enter="handleSelect(option)"
          @keydown.space.prevent="handleSelect(option)"
        >
          <!-- Radio button + label -->
          <div class="d-flex align-center flex-grow-1 min-width-0">
            <v-icon class="mr-3" color="rgba(0,0,0,0.54)">mdi-radiobox-blank</v-icon>
            <span class="body-1">{{ option.label }}</span>
          </div>

          <!-- Layout shape preview -->
          <div class="layout-preview flex-shrink-0">
            <!-- Billboard: single wide rectangle -->
            <div v-if="option.type === 'billboard'" class="layout-shape" style="height: 42px" />

            <!-- Triple Component: 3 equal columns -->
            <div v-else-if="option.type === 'triple'" class="d-flex layout-cols">
              <div class="layout-shape layout-col" style="height: 42px" />
              <div class="layout-shape layout-col" style="height: 42px" />
              <div class="layout-shape layout-col" style="height: 42px" />
            </div>

            <!-- Metric Summary: 4 equal columns, shorter height -->
            <div v-else-if="option.type === 'metrics-summary'" class="d-flex layout-cols">
              <div class="layout-shape layout-col" style="height: 26px" />
              <div class="layout-shape layout-col" style="height: 26px" />
              <div class="layout-shape layout-col" style="height: 26px" />
              <div class="layout-shape layout-col" style="height: 26px" />
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";

export default {
  name: "AddComponentPicker",
  components: { DrawerToolbar },
  props: {
    context: {
      type: String,
      required: true,
      validator: (v) => ["topSection", "programList"].includes(v),
    },
  },
  computed: {
    componentOptions() {
      const allOptions = [
        { type: "billboard", label: "Billboard" },
        { type: "triple", label: "Triple Component" },
        { type: "metrics-summary", label: "Metric Summary" },
      ];

      if (this.context === "programList") {
        return allOptions.filter((o) => o.type !== "metrics-summary");
      }

      return allOptions;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleSelect(option) {
      this.$emit("select", option);
    },
  },
};
</script>

<style scoped>
.section-title {
  font-size: 16px;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.87);
}

.option-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.option-card:hover {
  border-color: var(--v-brandPrimary-base);
  background-color: #f5fbfe;
}

.min-width-0 {
  min-width: 0;
}

.layout-preview {
  width: 162px;
}

.layout-shape {
  background-color: #d9d9d9;
  border-radius: 2px;
}

.layout-cols {
  gap: 8px;
}

.layout-col {
  flex: 1 0 0;
  min-width: 0;
}
</style>
